import React,{useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import "./catogory.css";
import $ from 'jquery';
import { Card, CardBody, Button, Input, FormGroup, Label } from 'reactstrap';
import Table from './common/Table';
const common = require('../utils/Common');

const DiscountApply = () => {
  const navigate = useNavigate();
  const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
  const [coupans, setCoupans] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [editValues, setEditValues] = useState(null);
  const [page, setPage] = useState(1);
 
  useEffect(()=>{
    checkAccess();
  },[]);

  const checkAccess = async () => {
    let rights = await common.checkAccessRights(window.location.pathname);
    if (!rights.view) {
      alert("Access Denied");
      navigate("/");
      return;
    } else {
      setUserRights(rights);
      fetchCoupans();
    }
  }

  const fetchCoupans = async (limit = 10, offset = 0, search = {}, isExport = 0, loader = true, reset = false) => {
    if (reset) {
        setPage(1);
        offset = 0;
    } else {
        setPage(offset / limit + 1);
    }
    const data = {
      action: "read"
    }
    if (!isExport) {
      data.limit = limit;
      data.offset = offset;
    }
		let response = await common.apiRequest('post', '/admin/crud-coupan', data, loader);
		if (response.status == 200) {
			if (response.data.code == 'success') {
        setCoupans(response.data.data);
        setTotalRecords(response.data.totalRecords);
			} else {
        alert(response.data.error);
      }
		} else {
      alert(response.data.error);
		}
  }

  const saveEditCoupan = async () => {
    const coupan = $('#coupan').val();
    const discountType = $('#discount_type').val();
    const discountValue = $('#discount_value').val();
    const startDate = $('#start_date').val();
    const endDate = $('#end_date').val();
    const minOrderAmount = $('#min_order_amount').val();
    const maxDiscount = $('#max_discount').val();
    const maxUsagePerUser = $('#max_usage_per_user').val();
    const description = $('#description').val();

    if (!coupan || !discountType || !discountValue || !startDate || !endDate || !maxDiscount || !maxUsagePerUser) {
      alert("Please fill all required fields");
      return;
    }
    const data = {
      action: editValues ? "update" : "create",
      coupan,
      discount_type: discountType,
      discount_value: discountValue,
      min_order_amount: minOrderAmount,
      max_discount: maxDiscount,
      max_usage_per_user: maxUsagePerUser,
      start_date: startDate,
      end_date: endDate,
      description: description,
      id: editValues ? editValues.id : 0
    }
		let response = await common.apiRequest('post', '/admin/crud-coupan', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
        alert(response.data.message);
        cancelFormFields();
        setEditValues(null);
        fetchCoupans(10, (page - 1) * 10, {}, 0, true, false);
			} else {
        alert(response.data.error);
      }
		} else {
      alert(response.data.error);
		}
  }

  const editCoupan = (row) => {
    setEditValues(row);
    const ids = ['coupan', 'description', 'discount_type', 'discount_value', 'start_date', 'end_date', 'min_order_amount', 'max_discount', 'max_usage_per_user'];
    for (const id of ids) {
      $('#'+id).val(row[id]);
    }
  }

  const cancelFormFields = () => {
    const ids = ['coupan', 'description', 'discount_type', 'discount_value', 'start_date', 'end_date', 'min_order_amount', 'max_discount', 'max_usage_per_user'];
    for (const id of ids) {
      $('#'+id).val('');
    }
  }

  const deactivateActivateCoupan = async (row, flag) => {
    const data = {
      action: "activate_deactivate_coupan",
      active: flag,
      id: row ? row.id : 0
    }
		let response = await common.apiRequest('post', '/admin/crud-coupan', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
        alert(response.data.message);
        fetchCoupans(10, (page - 1) * 10, {}, 0, true, false);
			} else {
        alert(response.data.error);
      }
		} else {
      alert(response.data.error);
		}
  }

  return (
    <>
      <div className='container'>
        <div className='col-md-12'>
          <h4 className='mainhead'>Coupons System</h4>
        </div>
        <Card>
          <CardBody>
            <FormGroup>
              <Label for="coupan">Coupon Code <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="text"
                id="coupan"
              />
            </FormGroup>
            <FormGroup>
              <Label for="description">Description <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="text"
                id="description"
              />
            </FormGroup>
            <FormGroup>
              <Label for="discount_type">Discount Type (% or Flat) <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="select"
                id="discount_type"
              >
                <option value="">Select Discount Type</option>
                <option value="percent">Percentage (%)</option>
                <option value="flat">Flat Amount</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="discount_value">Discount Value <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="number"
                id="discount_value"
              />
            </FormGroup>
            <FormGroup>
              <Label for="min_order_amount">Minimum Order Amount (Optional)</Label>
              <Input
                type="number"
                id="min_order_amount"
              />
            </FormGroup>
            <FormGroup>
              <Label for="min_order_amount">Maximum Discount <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="number"
                id="max_discount"
              />
            </FormGroup>
            <FormGroup>
              <Label for="min_order_amount">Max Usage Per User <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="number"
                id="max_usage_per_user"
              />
            </FormGroup>
            <FormGroup>
              <Label for="start_date">Enter Start Date <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="date"
                id="start_date"
              />
            </FormGroup>
            <FormGroup>
              <Label for="end_date">Enter End date <span style={{ color: "red" }}>*</span></Label>
              <Input
                type="date"
                id="end_date"
              />
            </FormGroup>

            <Button className='btn btn-success' onClick={saveEditCoupan}>Save Coupon</Button>
            <Button className='btn btn-danger ml-3' onClick={cancelFormFields}>Cancel</Button>
          </CardBody>
        </Card>

        <div className='mt-5'>
          <Table
            columns={[
              {
                header: "Coupon Code",
                accessor: "coupan"
              },
              {
                header: "Description",
                accessor: "description"
              },
              {
                header: "Discount Type",
                accessor: "discount_type",
                render: row => {
                  return row.discount_type == "percent" ? "Percent(%)" : "Flat"
                }
              },
              {
                header: "Discount Value",
                accessor: "discount_value"
              },
              {
                header: "Min. Order Amount",
                accessor: "min_order_amount"
              },
              {
                header: "Max Discount",
                accessor: "max_discount"
              },
              {
                header: "Max Usage Per User",
                accessor: "max_usage_per_user"
              },
              {
                header: "Start Date",
                accessor: "start_date"
              },
              {
                header: "End Date",
                accessor: "end_date"
              },
              {
                header: "Action",
                render: row => (
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button className="btn btn-warning btn-sm" onClick={() => editCoupan(row)}>Edit</button>
                    {row.active ? (
                      <button className="btn btn-danger btn-sm" onClick={() => deactivateActivateCoupan(row, 0)}>De-Activate</button>
                    ) : (
                      <button className="btn btn-success btn-sm" onClick={() => deactivateActivateCoupan(row, 1)}>Activate</button>
                    )}
                  </div>
                )
              }
            ]}
            data={coupans}
            totalRecords={totalRecords}
            pageSize={10}
            currentPage={page}
            onPageChange = {(limit, offset, search, reset) =>{
                fetchCoupans(limit, offset, search, 0, true, reset);
            }}
          />
        </div>
      </div>
    </>
  )
}

export default DiscountApply
